import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { FormControl } from '@angular/forms';
//http://nataliesmith.ca/blog/angular-material-filter-table

//import { RepositoryService } from './services/repository.service';
//import { Owner } from './models/owner';
//https://code-maze.com/angular-material-table/
//https://code-maze.com/net-core-series/


//export interface PeriodicElement {
//  name: string;
//  position: number;
//  weight: number;
//  symbol: string;
//}
//const ELEMENT_DATA: PeriodicElement[] = [
//  { position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H' },
//  { position: 2, name: 'Helium', weight: 4.0026, symbol: 'He' },
//  { position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li' },
//  { position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be' },
//  { position: 5, name: 'Boron', weight: 10.811, symbol: 'B' },
//  { position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C' },
//  { position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N' },
//  { position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O' },
//  { position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F' },
//  { position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne' },
//];
//https://material.angular.io/components/table/overview

import { CallEventsService } from './services/call-events.service';

@Component({
  selector: 'app-mat-table',
  templateUrl: './mat-table.component.html',
  styleUrls: ['./mat-table.component.scss'],
  //providers: [colSpecialCharsPipe]
})
export class MatTableComponent implements OnInit {
  screenTitle: string = "Call Events";
  isLoading: boolean = true;

  nameFilter = new FormControl('');
  idFilter = new FormControl('');
  colourFilter = new FormControl('');
  petFilter = new FormControl('');

  //people = [
  //  {
  //    name: 'John',
  //    id: 1,
  //    colour: 'Green',
  //    pet: 'Dog'
  //  },
  //  {
  //    name: 'Sarah',
  //    id: 2,
  //    colour: 'Purple',
  //    pet: 'Cat'
  //  },
  //  {
  //    name: 'Lindsay',
  //    id: 3,
  //    colour: 'Blue',
  //    pet: 'Lizard'
  //  },
  //  {
  //    name: 'Megan',
  //    id: 4,
  //    colour: 'Orange',
  //    pet: 'Dog'
  //  }
  //];

  dataSource = new MatTableDataSource();
  columnsToDisplay = []; //['name', 'id', 'favouriteColour', 'pet'];

  constructor(private callEventsService: CallEventsService) {
    this.callEventsService.getItems().subscribe((res: any[]) => {
      this.dataSource.data = res;
      this.isLoading = false;
      this.dataSource.filterPredicate = this.tableFilter();
      this.columnsToDisplay = Object.keys(res[0]);
    }); //this.dataSource.data = this.people;
    //https://stackoverflow.com/questions/48470046/angular-material-table-filterpredicate
    //https://stackoverflow.com/questions/49939979/filtering-specific-column-in-angular-material-table-with-filtering-in-angular/49940108
    //https://hashnode.com/post/complex-filtering-on-nested-objects-angular-6-cjo73sgq1009vr9s2iwupt51c
    //https://blog.angular-university.io/angular-material-data-table/
    //https://stackblitz.com/angular/dnbermjydavk?file=app%2Ftable-overview-example.ts
  }
  tableFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return data.VQuad_Timestamp.toLowerCase().indexOf(searchTerms.VQuad_Timestamp) !== -1;
        //&& data.id.toString().toLowerCase().indexOf(searchTerms.id) !== -1
        //&& data.colour.toLowerCase().indexOf(searchTerms.colour) !== -1
        //&& data.pet.toLowerCase().indexOf(searchTerms.pet) !== -1;
    }
    return filterFunction;
  }

  filterValues = {
    VQuad_Timestamp: '',
    id: '',
    colour: '',
    pet: ''
  };

  ngOnInit() {

    this.nameFilter.valueChanges
      .subscribe(
      VQuad_Timestamp => {
          this.filterValues.VQuad_Timestamp = VQuad_Timestamp;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.idFilter.valueChanges
      .subscribe(
        id => {
          this.filterValues.id = id;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.colourFilter.valueChanges
      .subscribe(
        colour => {
          this.filterValues.colour = colour;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.petFilter.valueChanges
      .subscribe(
        pet => {
          this.filterValues.pet = pet;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
  }



  //public displayedColumns = ['name', 'dateOfBirth', 'address', 'details', 'update', 'delete'
  //];
  //public dataSource = new MatTableDataSource<Owner>();

  //constructor(private repoService: RepositoryService) { }

  //ngOnInit() {
  //  this.getAllOwners();
  //}

  //public getAllOwners = () => {
  //  this.repoService.getData('api/owner')
  //    .subscribe(res => {
  //      this.dataSource.data = res as Owner[];
  //    })
  //}

  //public redirectToDetails = (id: string) => {

  //}

  //public redirectToUpdate = (id: string) => {

  //}

  //public redirectToDelete = (id: string) => {

  //}





  //ngOnInit() {
  //}

  //displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
  //dataSource = ELEMENT_DATA;
}
